export enum TickmillProductType {
  CFD = 1,
  ETD = 2,
  STOCKS = 3,
  SQF = 4,
}

export type BaseProduct = TickmillProductType.CFD | TickmillProductType.ETD

export const getTickmillProductTypeName = (value: TickmillProductType): string => {
  return TickmillProductType[value]
}

export const isTickmillProductTypeCFD = (
  productType: TickmillProductType | TickmillProductType[]
): boolean => {
  if (Array.isArray(productType)) {
    return productType.includes(TickmillProductType.CFD)
  }
  return productType === TickmillProductType.CFD
}

export const isTickmillProductTypeETD = (
  productType: TickmillProductType | TickmillProductType[]
): boolean => {
  if (Array.isArray(productType)) {
    return productType.includes(TickmillProductType.ETD)
  }
  return productType === TickmillProductType.ETD
}

export const isTickmillProductTypeStocks = (
  productType: TickmillProductType | TickmillProductType[]
): boolean => {
  if (Array.isArray(productType)) {
    return productType.includes(TickmillProductType.STOCKS)
  }
  return productType === TickmillProductType.STOCKS
}
